import translate from 'counterpart';

export default (schemaName, path) => {
  return translate(`labels.${schemaName}.${path}`);
};



// WEBPACK FOOTER //
// ./app/lib/labelTranslator.js